/* global window, document, URL, Blob */
import * as R from 'ramda';

export default function TrainingDocumentController(
  $q,
  eduDataService,
  utilityService
) {
  const vm = this;

  vm.handleDownloadDocumentClick = _handleDownloadDocumentClick;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    vm.media.thumbnailUrl = utilityService.sanitizeImageSrc(vm.media.thumbnailUrl);
  }

  function _handleDownloadDocumentClick() {
    eduDataService.downloadDocument(vm.media.contentId)
      .then((downloadDocumentResponse, status, headers) => { // eslint-disable-line no-unused-vars
        const contentDisposition = downloadDocumentResponse.headers('Content-Disposition');
        if (vm.media.fileName === null || vm.media.fileName === undefined) {
          vm.media.fileName = '';
        }
        const reverseFileName = vm.media.fileName.split('').reverse().join('');
        if (reverseFileName.indexOf('.') < 0 && !R.isNil(contentDisposition)) {
          const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/g.exec(contentDisposition);
          vm.media.fileName = matches && matches.length > 1 ? matches[1] : null;
          vm.media.fileName = vm.media.fileName.split('"').join('');
        }
        const blob = new Blob(
          [downloadDocumentResponse.data],
          { type: vm.media.mimeType, }
        );
        // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, vm.media.fileName);
        } else {
          const anchor = document.createElement('a');
          document.body.appendChild(anchor);
          anchor.setAttribute('type', 'hidden');

          anchor.href = URL.createObjectURL(blob);
          anchor.download = vm.media.fileName;
          anchor.target = '_self';
          anchor.click();

          // anchor.clconst anchor = document.createElement('a');
          // anchor.clconst url = URL.createObjectURL(blob, { oneTimeOnly: true });
          // anchor.clanchor.href = url;
          // anchor.clanchor.target = '_blank';
          // anchor.clanchor.click();
        }
      });
  }
}

TrainingDocumentController.$inject = [
  '$q',
  'eduDataService',
  'utilityService'
];
